import $ from "jquery"
import * as diff from "diffhtml"
import bootstrap from "bootstrap.native"
import canvasTemplate from "../../views/interface/canvas.html"
import Combobox from "../interface/combobox.js"
import ComboboxUI from "../interface/combobox"
import Components from "../components"
import Drag from "./drag"
import entities from "entities"
import {EventEmitter} from "events"
import formatter from "../model/formatter"
import Hook from "../hook"
import interfaceTemplate from "../../views/interface.html"
import loginTemplate from "../../views/login.html"
import Modal from "./modal"
import serializeForm from "../util/serializeForm"
import Session from "../model/session"
import swal from "sweetalert"
import templater from "../interface/templater"
import Window from "../model/window"

// Vue related

import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
const {drawVueManualModal} = require("../interface/vueManualModal")

Vue.use(BootstrapVue)

Vue.config.devtools = false

/**
 * Canvas class, contains most render functions and handles GUI
 * @property {element} element - base element reference
 * @property {Array} draggers - Drag classes
 * @property {element} anchorElement - Anchor element(drag related)
 * @property {boolean} fullscreen - If fullscreen or kiosk
 * @property {Session} session - Session reference
 * @property {number} x - anchor x position
 * @property {number} y - anchor y position
 */
export default class Canvas extends EventEmitter {
  /**
   * @param {Session} session - session reference
   */
  constructor(session) {
    super()

    this.element = null
    this.session = null
    this.fullscreen = null
    this.draggers = []
    this.anchorElement = null
    this.x = null
    this.y = null

    // Initialize the modals (Small, Medium, Large and extra large variants)
    // Modals are in the index.html, bootstrap native takes care of setting modal content,
    // and hiding/showing the modals
    window.extraLargeModalInstance = new bootstrap.Modal(extraLargeModal, {
      content: "<p></p>",
      backdrop: "static",
    })

    window.largeModalInstance = new bootstrap.Modal(largeModal, {
      content: "<p></p>",
    })

    window.mediumModalInstance = new bootstrap.Modal(mediumModal, {
      content: "<p></p>",
    })

    window.smallModalInstance = new bootstrap.Modal(smallModal, {
      content: "<p></p>",
    })

    // Listeners
    // Modal listeners for closing possible page load animations that start
    window.smallModal.addEventListener(
      "hide.bs.modal",
      () => {
        this.closeProcedure()
      },
      false,
    )

    window.mediumModal.addEventListener(
      "hide.bs.modal",
      () => {
        this.closeProcedure()
      },
      false,
    )

    window.largeModal.addEventListener(
      "hide.bs.modal",
      () => {
        this.closeProcedure()
      },
      false,
    )

    window.extraLargeModal.addEventListener(
      "hide.bs.modal",
      () => {
        this.closeProcedure()
      },
      false,
    )

    // When a JavaScript runtime error (including syntax errors and exceptions thrown within handlers) occurs,
    // an error event using interface ErrorEvent is fired.
    // If the thrown event was 'catched' this function is not called
    // this function is added to make sure all disabled/loading windows are enabled again.
    // A global warning is show in the corner of the window
    window.addEventListener("error", function() {
      session.tabs.forEach(async function(w) {
        while (w != null) {
          if (w.loading) {
            w.toggleLoading(false)

            window.session.activeWindow.showNotification(
              "danger",
              window.session.translations.AdminDesktop_AlertOperationCancelled,
            )

            w = null
          } else if (w.sub && w.sub.window) {
            w = w.sub.window
          } else {
            w = null
          }
        }
      })
    })

    this.modal = new Modal(window, this)

    let _this_ = this

    this.session = session || new Session("")

    let components = new Components(this.session)
    components.init(document)

    diff.addTransitionState("replaced", (oldel, newel) => {
      components.replace(oldel, newel)
    })

    diff.addTransitionState("attributeChanged", (el, ...args) => {
      components.update(el, ...args)
    })

    diff.addTransitionState("textChanged", (el, ...args) => {
      components.change(el, ...args)
    })

    diff.addTransitionState("attached", element => {
      components.attach(element)
    })

    diff.addTransitionState(
      "attributeChanged",
      (element, attributeName, oldValue, newValue) => {
        if (attributeName === "value") {
          $(element).val(entities.decodeHTML(newValue))
        }
      },
    )

    this.session.on("updated", () => this.render())
    // this.render()

    Hook.register("afterToggleLoading", this, window => {
      $(window.element)
        .find(".loading")
        .last()
        .toggleClass("hide", !window.loading)
    })

    $("body").on("change", ".login [name=language]", function() {
      session.switchLanguage($(this).val())
    })

    $("body").on("focus", "input, .cke_editable[contenteditable]", () => {
      $(".menu").addClass("hide")
      $(".date-picker").removeClass("active")
      if ($(this).is(".date") && !$(this).is(":disabled")) {
        $(this)
          .parent()
          .find(".menu")
          .removeClass("hide")
        $(this)
          .parent()
          .addClass("active")
      }
    })

    $("body").on("click", ".window", function checkForMsgBoxes() {
      $(this)
        .find(".modal-content form.simple")
        .submit()
    })

    $("body").on("keyup", ".window", function checkForMsgBoxes() {
      $(this)
        .find(".modal-content form.simple")
        .submit()
    })

    $("body").on("click", ".counter", e => {
      if ($(this).hasClass("decrement") || $(this).hasClass("increment")) {
        e.preventDefault()
        e.stopImmediatePropagation()
        let minValue = Number(
          $(this)
            .parent()
            .find(".counter.value")
            .attr("min"),
        )
        let maxValue = Number(
          $(this)
            .parent()
            .find(".counter.value")
            .attr("max"),
        )
        let current =
          Number(
            $(this)
              .parent()
              .find(".counter.value")
              .val(),
          ) || 0
        let newValue = Math.min(
          !isNaN(maxValue) ? maxValue : 9999,
          Math.max(
            !isNaN(minValue) ? minValue : -9999,
            current + ($(this).hasClass("increment") ? 1 : -1),
          ),
        )
        $(this)
          .parent()
          .find(".counter.value")
          .val(String(newValue || "") || null)
        $(this)
          .parent()
          .find(".counter.display")
          .text(String(newValue))
      }
    })

    if (global.location.hash.slice(0, "#Affiliate=".length) == "#Affiliate=") {
      this.session.affiliate = location.hash.slice("#Affiliate=".length, location.hash.length)
    }

    if (!this.session.kiosk && this.session.setup == null) {
      location.hash = ""
    }

    Hook.register("afterFocus", this, window => {
      if (!this.session.kiosk) {
        location.hash = "#" + window.id
      }

      $(".active-window").removeClass("active-window")
      $(window.parent ? window.parent.element : window.element).addClass(
        "active-window",
      )

      this.renderTabs()
    })

    window.onhashchange = () => {
      let id = location.hash.slice(1)
      let window = this.session.windows[id]

      if (window) {
        window.focus()
      }
    }

    // Toggle aside
    $(document).on("click", ".nav .logo", () => {
      if (
        this.session.kiosk ||
        (this.session.comboboxes.selectedValues == null &&
          this.session.moduleMenu == null)
      ) {
        return
      }

      $(".interface").toggleClass("hide-aside")

      for (let i = 1; i <= 15; i++) {
        setTimeout(() => {
          $(window).resize()
        }, 10 * i)
      }
    })

    // Detect value change for all windows
    $(document)
      .on("change value-change", ".window [name]", valueChange)
      .on("blur", ".window [name][data-html-editor]", valueChange)
      .on("blur", ".window [name][contenteditable]", valueChange)

    function valueChange(e, arg) {
      let $this = $(this)
      if ($this.hasClass("ignore-change")) {
        return
      }

      let $window = $this.closest(".window")
      let window = _this_.session.getClosestWindow($window)

      if (
        window == null ||
        window.output == null ||
        window.output.Data == null ||
        window.output.Data.Rows == null
        // || window.output.Data.Rows.length == 0
      ) {
        return
      }

      let val = null
      if (arg && e.type === "value-change") {
        val = arg
      } else if ($this.is("[data-html-editor]")) {
        let instanceID = $(this).attr("id")
        val = CKEDITOR.instances[instanceID].getData()
      } else if ($this.is("[contenteditable]")) {
        val = $this.text()
      } else if ($this.is("input[type=checkbox]")) {
        val = $this.prop("checked")
      } else if ($this.is("input[type=hidden]")) {
        let cb = ComboboxUI.getClass($(this).closest(".combobox"))
        if (cb.specification.type === "multi-selector") {
          val = JSON.stringify(cb.oldValueList)
        } else {
          val = $this.val() || null
        }
      } else {
        val = $this.val() || null
      }

      val = val !== null && typeof val === "string" ? val.trim() : val

      let $row = $this.closest("[data-row-index]")
      let name = $this
        .attr("name")
        .split(/\[|\]/g)
        .shift()

      let index = window.output.Table.Columns.map((col, index) =>
        col.Name === name ? index : null,
      )
        .filter(index => index !== null)
        .pop()

      let row = $row.attr("data-row-index")

      if (typeof row === "undefined") {
        row = 0
      }

      if (!window || !window.output || !window.output.Table.Rows.length) {
        return
      }

      let changedCell = window.processChange(row, index, val)

      if (changedCell) {
        let dirty =
          window.output.Table.Rows[row].filter(cell => cell.IsDirty).length > 0

        $this.closest(".form-field").toggleClass("dirty", changedCell.IsDirty)
        $this
          .closest(".table-row")
          .toggleClass("dirty", dirty)
          .find(".selection-box input")
          .prop("checked", dirty)
          .change()
      }

      // Numeric field
      if ($(this).is(".number")) {
        let type = $(this).is("input") ? "input" : "field"

        let col = window.output.Table.Columns[index]

        if (!col) {
          col = window.output.Table.Columns[index]
        }

        if (!col) {
          return
        }

        let round = col.NumericScale
        val = Number(val.replace(",", "."))

        $(this).toggleClass("incorrect", isNaN(val))

        if (typeof round === "number" && val) {
          let updatedVal = val.toFixed(round)

          if ($(this).attr("min")) {
            let minVal = Number($(this).attr("min"))
              .toFixed(round)
              .replace(",", ".")

            if (+minVal > +updatedVal) {
              updatedVal = minVal
            }
          }

          if ($(this).attr("max")) {
            let maxVal = Number($(this).attr("max"))
              .toFixed(round)
              .replace(",", ".")

            if (+maxVal < +updatedVal) {
              updatedVal = maxVal
            }
          }

          if (type == "input") {
            $(this).val(updatedVal)
          } else {
            $(this).text(updatedVal)
          }
        }
      }

      let parentwindow = window
      if (window.parent != null) {
        parentwindow = window.parent
      }

      if (
        parentwindow.sub != null &&
        parentwindow.sub.window != null &&
        parentwindow.output != null &&
        parentwindow.output.Data != null &&
        parentwindow.output.Data.Type != "tree"
      ) {
        // if parent is not dirty and sub is dirty, disable parent
        parentwindow.renderOptions.inactive =
          parentwindow.sub.window.isDirty() && !parentwindow.isDirty()
        $(parentwindow.element).toggleClass(
          "inactive",
          parentwindow.renderOptions.inactive,
        )

        // if parent is dirty disable sub
        parentwindow.sub.window.renderOptions.inactive = parentwindow.isDirty()
        $(parentwindow.sub.window.element).toggleClass(
          "inactive",
          parentwindow.sub.window.renderOptions.inactive,
        )
      }
    }

    // Key actions(enter and escape)
    $(document).on(
      "keydown",
      ".window input[name], .window [contenteditable][name]",
      async function onKeyUpAction(e) {
        let window = _this_.session.getClosestWindow(this)

        if (e.which !== 13 && e.which !== 27) {
          return
        }

        let $this = $(this)
        let isInput = $this.is("input")

        if (
          window.options.customKeyEvents ||
          window.output.Request.Prefix == "New" ||
          $this.is(".no-field") ||
          (isInput && $this.is(".combobox-input"))
        ) {
          return
        }

        let isCalender = $this.is("input.date") || $this.is(".field.date")

        switch (e.which) {
          // enter
          case 13: {
            if ($this.hasClass("ignore-next")) {
              return
            }

            if (isInput) {
              let nextindex = Number($this.attr("data-field-index")) + 1
              let $form = $this.closest(".form-view")
              let $next = $form.find(`[data-field-index='${nextindex}']`)

              if ($next.length) {
                $this.blur()
                $next.focus()
              }
            } else {
              let index = $this.index()
              let $thisRow = $this.closest(".table-row")
              let $thisGroup = $this.closest(".table-row-group")
              let isInGroup = $thisGroup.length > 0
              let isLast = isInGroup
                ? $thisGroup.is(":last-child")
                : $thisRow.is(":last-child")

              if (isLast && $this.closest(".bulkedit").length > 0) {
                shouldAddNewLine(window, $this, $thisRow, true)
                if (!$this.val() && !$this.text()) {
                  $thisRow
                    .find(".selection-box input")
                    .prop("checked", false)
                    .change()
                }
              }

              let $nextRow = isInGroup
                ? $thisGroup
                    .next()
                    .find(".table-row")
                    .first()
                : $thisRow.next()

              $nextRow
                .children()
                .eq(index)
                .focus()
            }

            if (isCalender) {
              $this
                .parent()
                .find(".calendar")
                .addClass("hide")
            }

            break
          }
          // escape
          case 27: {
            if ($this.hasClass("ignore-reset")) {
              return
            }

            if (isInput) {
              let colId = $this.attr("data-field-index")
              let originalVal =
                window.output.Table.Rows[0][colId].Value || String()
              $this.val(originalVal)
            } else {
              let $row = $this.closest(".table-row")
              if ($row.hasClass("new-row")) {
                $this.text("")
                return
              }
              let row = $row.attr("data-row-index")
              let index = $this.attr("data-field-index")
              if (
                !window.bulkedit ||
                !window.output.Table ||
                !window.output.Table.Rows
              ) {
                return
              }
              let cell = window.output.Table.Rows[row][index]
              let originalValue = cell.SerializedValue
              originalValue =
                formatter.parseValue(cell.Column, originalValue) || String()
              $this.text(originalValue)
              placeCaretAtEnd($this.get(0))
            }
            if (isCalender) {
              $this
                .parent()
                .find(".calendar")
                .addClass("hide")
            }
            $this.blur()
            $this.change()
            break
          }
        }
      },
    )

    function placeCaretAtEnd(el) {
      el.focus()
      if (
        typeof window.getSelection != "undefined" &&
        typeof document.createRange != "undefined"
      ) {
        let range = document.createRange()
        range.selectNodeContents(el)
        range.collapse(false)
        let sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
      } else if (typeof document.body.createTextRange != "undefined") {
        let textRange = document.body.createTextRange()
        textRange.moveToElementText(el)
        textRange.collapse(false)
        textRange.select()
      }
    }

    $(document).on("click", "[data-row-index]", function() {
      let id = $(this)
        .closest(".window")
        .attr("data-window-id")
      let active = _this_.session.windows[id]

      if (active.bulkedit || (active.sub && active.sub.window.bulkedit)) {
        return
      }

      /*
      let $checkbox = $(this).find(".selection-box input[type=checkbox]")
      $checkbox.prop("checked", !$checkbox.prop("checked"))
      $checkbox.change()
      */
    })

    $(document).on("click", "[data-row-index] [href]", e => {
      // stop selection of row when clicking link (image link)
      e.stopImmediatePropagation()
    })

    let rowdblclicktimer = null
    let rowdblclicktarget = null

    $(document).on("click", "[data-row-index]", function() {
      let id = $(this)
        .closest(".window")
        .attr("data-window-id")
      let subject = $(this).attr("data-subject")
      let key = $(this).attr("data-key")
      let keyReference = $(this).attr("data-keyreference")
      let active = _this_.session.windows[id]

      if (!rowdblclicktimer || rowdblclicktarget !== this) {
        rowdblclicktarget = this
        rowdblclicktimer = setTimeout(() => {
          rowdblclicktimer = null
        }, 500)
        return
      }

      rowdblclicktarget = null
      rowdblclicktimer = null

      if (
        (active.output.Options.OpenRow == "Default" && active.bulkedit) ||
        (active.output.Options.OpenRow == "Disabled" &&
          $(this).find(".open-row").length === 0 &&
          $(event.target).hasClass("open-row"))
      ) {
        return
      }

      // If option RowClickable cancel this listener
      if (
        active.output.Options.RowClickable === false &&
        !$(event.target).hasClass("open-row")
      ) {
        return
      }

      // do not open the row if  any of the columns has a (custom) css-class open-row except when that column is clicked
      // if (
      //   $(this).find(".open-row").length !== 0 &&
      //   !$(event.target).hasClass("open-row")
      // ) {
      //   return
      // }

      let index = $(this).attr("data-row-index")
      let fieldIndex = null

      // if event.target has attribute 'open-row', provide clicked cellIndex to window.openRow function
      if (
        $(event.target).hasClass("open-row") &&
        !$(event.target).is(":empty")
      ) {
        fieldIndex = $(event.target).attr("data-field-index")
      }

      active.openRow(index, fieldIndex, subject, key, keyReference)
    })

    $(document).on(
      "change",
      ".window .table-index .selection-box input",
      function selectAll() {
        let checkedAll = $(this).prop("checked")
        $(this)
          .closest(".table-view")
          .find(".table-body .table-row .selection-box input")
          .each(function() {
            $(this).prop("checked", checkedAll)
            $(this).change()
          })
      },
    )
    $(document).on(
      "click",
      ".window .table-body .table-row .selection-box",
      function cancelClick(e) {
        e.stopImmediatePropagation()
      },
    )

    $(document).on(
      "change",
      ".window .table-body .table-row .selection-box input",
      function selectOne() {
        let $w = $(this).closest(".window")
        let window = _this_.session.getClosestWindow($w)
        let rowIndex = $(this)
          .closest("[data-row-index]")
          .attr("data-row-index")
        let checked = $(this).prop("checked")

        window.selectRow(rowIndex, checked)

        $(this)
          .closest(".table-row")
          .toggleClass("dirty", checked)
        $w.find("[data-select-count]").text(window.selection.length)
      },
    )

    $(document).on("mousedown", ".canvas > .tabs .tab", function(e) {
      if (e.which !== 2) {
        return false
      }

      let id = $(this).attr("data-window-target")
      _this_.session.windows[id].dispose()
    })

    let dblclicktimer = null
    let clicktarget = null

    $(document).on("click", "[data-toggle-lower-field]", function selectOne() {
      let $this = $(this)
      let window = _this_.session.getClosestWindow(this)
      let $lower = $this.closest(".table-row-group").find(".lower-field")

      if (!$lower.length) {
        $lower = $this
          .closest(".table-row.grouped-row")
          .nextUntil(".grouped-row")
      }

      $lower.toggleClass("hide")
      window.resize()
    })

    $(document).on(
      "click",
      "[data-show-all-lower-fields]",
      function selectOne() {
        let $this = $(this)
        let window = _this_.session.getClosestWindow(this)
        let numberOfShown = 0

        $this
          .closest(".table-view")
          .find(".lower-field")
          .each(function() {
            if ($(this).hasClass("hide")) {
              numberOfShown++
            }
          })

        $this
          .closest(".table-view")
          .find(".lower-field")
          .toggleClass("hide", numberOfShown == 0)
        window.resize()
      },
    )

    $(document).on(
      "change",
      ".window .table-body.bulkedit .table-row .combobox input[type='hidden']",
      function selectOne() {
        let $this = $(this)
        let $tr = $this.closest(".table-row")
        let window = _this_.session.getClosestWindow(this)

        shouldAddNewLine(window, $this, $tr, $this.val())

        if (!$tr.is(".new-row")) {
          compareBulkCellData()
        }
      },
    )

    function shouldAddNewLine(window, $this, $tr, val) {
      if (window.options.noNewLines) {
        return
      }

      if (
        $tr
          .parent()
          .is(
            ".table-row-group",
          ) /* $tr.parent().is(".table-row-group:last-child") && val*/
      ) {
        return
      }

      if ($this.closest(".table-row").is(":last-child") && val) {
        let $trClone = $tr.clone()
        $trClone.find("[contenteditable]").html("")
        $trClone.find(".combobox").each(function() {
          $(this)
            .find(".menu")
            .addClass("hide")
          $(this)
            .find("input")
            .val("")
          $(this)
            .find(".option.selected")
            .removeClass("selected")
          Combobox.update($(this).get(0))
        })
        $trClone.removeClass("dirty")
        $tr.after($trClone)
        $tr.find(".table-cell.selection-box input").prop("checked", true)
        $tr.addClass("dirty")
      }
    }

    $(document).on(
      "keypress",
      ".table-cell.number.field[contenteditable]",
      async function(e) {
        let asciiValue = e.keyCode || e.charCode
        if (asciiValue == 45) {
          // 45 is -, we want to allow this once at the start of the number
          if (
            this.textContent.charAt(0) != "-" &&
            this.textContent.charAt(0) != ""
          ) {
            this.textContent = "-" + this.textContent
            e.preventDefault()
            e.stopImmediatePropagation()
          }
        } else if (asciiValue == 46) {
          // 46 is . we want to allow this once
          if (this.textContent.indexOf(".") != -1) {
            e.preventDefault()
            e.stopImmediatePropagation()
          }
        } else if (asciiValue < 48 || asciiValue > 57) {
          // anything else we do not want the user to enter
          e.preventDefault()
          e.stopImmediatePropagation()
        }
      },
    )

    $(document).on("keyup input", ".field[contenteditable]", async function() {
      let oldContent = $(this).html()
      let newContent = $(this)
        .html()
        .replace(/<br([^>]*)>/g, "")

      if (oldContent != newContent) {
        $(this).html(newContent)
      }
    })

    $(document).on("submit", "form", e => e.preventDefault())

    // $(document).on('click', '.field[contenteditable]', function() {
    // 	console.log("clicky cell", $(this).is(".date-picker .date"))
    // 	$(this).trigger("focus")
    // })

    $(document).on("click", ".table-cell", function() {
      $(this)
        .find("[contenteditable=true]")
        .focus()
    })

    $(document).on(
      "blur",
      ".bulkedit .field[contenteditable]",
      function() {
        let $this = $(this)
        // cleanse
        $this.text($this.text())
        let window = _this_.session.getClosestWindow(this)
        window.resize()

        // compare data to original

        let $tr = $this.closest(".table-row")

        shouldAddNewLine(window, $this, $tr, $this.text())

        if ($tr.is(".new-row")) {
          // if(!$tr.is(":last-child")) {
          // 	$tr.addClass("dirty")
          // }
        } else {
          compareBulkCellData()
        }

        $this.change()
        return $this
      },
    )

    function compareBulkCellData() {
      return
      // let row = $this.closest(".table-row").attr("data-row-index")
      // let changed = false

      // $this.closest(".table-row").find("[name]").each(function() {
      // 	let name = $(this).attr("name").split(/\[|\]/g).shift()
      // 	let value = $(this).is("[contenteditable]") ? $(this).text() : $(this).val()
      // 	let index = $(this).is("[contenteditable]")
      // 		? $(this).attr("data-field-index")
      // 		: $(this).closest(".field").attr("data-field-index")
      // 	let window = _this_.session.activeWindow
      // 	if(!window.bulkedit && window.sub && window.sub.window.bulkedit) {
      // 		window = window.sub.window
      // 	}
      // 	if(!window.bulkedit || !window.output.Table || !window.output.Table.Rows) {
      // 		return
      // 	}
      // 	let originalValue = window.output.Table.Rows[row][index].Value

      // 	if (originalValue != value) {
      // 		changed = true
      // 	}
      // })

      // let isChecked = $this
      // 	.closest(".table-row")
      // 	.find(".selection-box input")
      // 	.prop("checked")

      // if(isChecked != changed) {
      // 	$this
      // 		.closest(".table-row")
      // 		.toggleClass("dirty", changed)
      // }
    }

    $("body").on("submit", ".login form", async function(e) {
      e.preventDefault()

      let el = $("button[clicked=1]")
      _this_.session.form = serializeForm(this)

      if (el.hasClass("login-screen-return")) {
        _this_.session.openScreen(null)
      } else if (el.hasClass("password-reset-button")) {
        _this_.session.form.userID = _this_.session.userID
        await _this_.session.executeAppWebservice(
          _this_.session.form,
          "ResetPassword",
          true,
        )
      } else if (el.length == 0 || el.hasClass("login-button")) {
        await _this_.session.auth(_this_.session.form)
      } else if (el.hasClass("password-lost-button")) {
        _this_.session.openScreen("ForgotPassword")
      } else if (el.hasClass("password-request-button")) {
        await _this_.session.executeAppWebservice(
          _this_.session.form,
          "LostPassword",
        )
      } else if (el.hasClass("register-button")) {
        _this_.session.openScreen("Register")
      } else if (el.hasClass("register-send-button")) {
        await _this_.session.executeAppWebservice(
          _this_.session.form,
          "Register",
        )
      }
    })

    $("body").on(
      "click",
      ".login form button",
      async function submitButtonClick() {
        $("button[clicked=1]", $(this).parents("form")).removeAttr("clicked")
        $(this).attr("clicked", "1")
      },
    )

    Hook.register("afterResize", this, this.correctTableHeaders)

    Hook.register("afterPaginate", this, async window => {
      $(window.element)
        .find(".scroll-container")
        .scrollTop(0)
    })

    $("body").on(
      "click",
      ".session.combobox .menu .dropdown-option",
      function switchSessionCombobox(e) {
        if (_this_.session.comboboxes.selectedValues == null) {
          _this_.session.comboboxes.selectedValues = {}
        }

        e.stopPropagation()

        let url = new URL(window.location.href)
        url.hash = "#Affiliate=" + $(this).data('value')
        window.open(url, '_blank')
        return;

        let alertObject = {
          text: _this_.session.translations.WarningAllWindowsWillClose,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: _this_.session.translations.Cancel,
            confirm: "OK",
          },
        }

        /*
				if confirmed
					set value in combobox and on session
					dispose all windows
				else
					do nothing
			*/
        swal(alertObject).then(shouldClose => {
          if (shouldClose) {
            // if close is clicked, shouldClose resolves to NULL
            // set the combobox value to the clicked item
            let $el = $(this).closest(".combobox")
            $el.find(".dropdown-option").removeClass("selected")
            $(this).addClass("selected")
            let cb = Combobox.getClass($el)
            e.stopImmediatePropagation()
            Combobox.selectAndClose(cb)

            // update the selectedValues property with the selected text, this gets send by every request to get the current warehouse

            _this_.session.comboboxes.selectedValues[
              $(this)
                .parents(".session.combobox")
                .data("session")
            ] = cb.oldValue
            // $(this).val()
            if (_this_.session.activeWindow) {
              // if we have any windows, force dispose them
              _this_.session.activeWindow.disposeAll()
            }
          }
        })
      },
    )

    $(document).on("click", "[data-menu-id]", async function treeClick() {
      // return when the menu node is disabled
      if ($(this).hasClass("disabled")) {
        return
      }

      let menuId = $(this).attr("data-menu-id")
      let menuNode = null
      let arMenuNodes = _this_.session.moduleMenu

      for (let i = 0; i < menuId.length; i++) {
        menuNode = arMenuNodes.find(x => x.ID == menuId.substr(0, i + 1))

        if (menuNode != null && menuNode.children != null) {
          arMenuNodes = menuNode.children
        }
      }

      // Notify the tutorial about the opened menunode, and try to handle url: and tutorial:
      _this_.session.tutorial.openMenuNodeNotifioncation(
        $(this).attr("data-menu-id"),
      )

      if (menuNode != null) {
        if (menuNode.Value.includes("tutorial:")) {
          _this_.session.tutorial.resetTutorial()

          return
        } else if (menuNode.Value.includes("url:")) {
          global.open(menuNode.Value.replace("url:", ""), "_blank")

          return
        }
      }

      $("body").addClass("avoid-clicks")
      // prevent doubleclick
      let el = $(this).get(0)

      if (dblclicktimer && clicktarget === el) {
        return
      }

      dblclicktimer = setTimeout(() => {
        dblclicktimer = null
      }, 300)

      clicktarget = el

      if ($(global.window).width() < 500) {
        $(".interface").toggleClass("hide-aside", true)
      }

      let window = new Window(_this_.session)
      window.loading = true
      _this_.session.tabs.unshift(window)

      try {
        await window.render()
        window.focus()

        let output = await _this_.session.request(
          "/Admin/WebServices/CoreWebServices.asmx/OpenMenuNode",
          {
            ID: $(this).attr("data-menu-id"),
          },
        )

        await window.process(output)
        window.loading = false
        await window.render()

        drawVueManualModal({
          windowID: window.id,
          helpUrl: window.output.Options.HelpUrl,
        })
      } catch (err) {
        $("body").removeClass("avoid-clicks")
        console.error(err)
        window.dispose()
      }
      $("body").removeClass("avoid-clicks")
    })
  }

  closeProcedure() {
    $(".window-body")
      .find(".cover")
      .fadeOut(300, () => {
        $(this).remove()
        // resolve(null)
      })
    global.session.activeWindow.toggleLoading(false)
  }

  /**
   * Render base layout
   * @returns {void}
   */
  render() {
    let wasLocked = $("body").hasClass("locked")
    $("body")
      .toggleClass("locked", this.session.locked && this.session.active)
      .toggleClass("unlocked", !this.session.locked && this.session.active)

    if (this.session.setup !== null) {
      return
    }

    if (!this.session.active || this.session.locked) {
      diff.innerHTML($(".login").get(0), loginTemplate.render(this.session))

      if (!this.session.active) {
        // $(".interface").replaceWith($("<div>").addClass("interface"))
      }

      return
    }

    if (wasLocked && !this.session.locked) {
      if (
        this.session.activeWindow != null &&
        !this.session.activeWindow.isDirty()
      ) {
        this.session.activeWindow.reload()
      }

      return
    }

    diff.innerHTML(
      $(".interface").get(0),
      interfaceTemplate.render(this.session),
    )

    if (
      this.session.kiosk ||
      (this.session.comboboxes.values == null &&
        this.session.moduleMenu == null)
    ) {
      $(".interface").toggleClass("hide-aside", true)
    }

    let oldElement = this.element
    this.element = $(".canvas").get(0)

    if (this.element !== oldElement) {
      this.bindEvents()
    }

    this.findAnchor()
    this.renderTabs()

    this.makeFullscreen(this.session.fullscreen)

    // Check if the user follows a tutorial
    this.session.tutorial.checkTutorialMode()
  }

  /**
   * find and set anchor element
   * @returns {void}
   */
  findAnchor() {
    this.anchorElement = $(this.element)
      .find("[data-window-anchor]")
      .get(0)
  }

  /**
   * Log user out
   * @see Session.logout
   * @returns empty
   */
  logoff() {
    this.session.logout()
    return
  }

  /**
   * show user settings
   * @returns {void}
   */
  usersettings() {
    let window = this.session.openWindow({
      Subject: "dbo.aspnet_Users",
      Prefix: "Single",
      Criteria: [{UserName: this.session.username}],
    })
  }

  /**
   * Render all tabs
   * @returns {void}
   */
  renderTabs() {
    let html = canvasTemplate.render(this.session)
    let tabsHtml = $("<div>")
      .html(html)
      .find(".tabs")
      .html()

    diff.innerHTML(
      $(this.element)
        .find(".tabs")
        .get(0),
      tabsHtml,
    )
  }

  /**
   * Update window
   * @param {Window} window - Window class
   * @param {Window} original - Original window
   * @returns {Promise} Promise
   */
  async update(window, original) {
    if (!window.element || !$.contains(document.body, window.element)) {
      window.element = window.parent
        ? $(window.parent.element)
            .find(".window.child")
            .get(0)
        : $('[data-window-id="' + window.id + '"]').get(0)
      await new Promise(resolve => setTimeout(resolve))
    }

    if (!window.element || !$.contains(document.body, window.element)) {
      console.log("Cannot render window due to missing HTML element.")
      return
    }

    let inlineStyle = $(window.element).attr("style")

    if (!window.customInit && navigator.userAgent.indexOf("Edge") != -1) {
      // only execute clearHTML() for Edge, as it breaks updating windows in Chrome.
      window.clearHTML()
    }

    // render window
    diff.outerHTML(window.element, templater.renderWindow(window))
    // $(window.element).html($(window.element).html())
    $(window.element).attr("style", inlineStyle)

    let activeWindow = null
    if (window != null && window.output.Table != null) {
      activeWindow = window
    }

    let editorsToInit = $(window.element)
      .find("[data-html-editor]")
      .each(function() {
        if ($(this).prop("disabled")) {
          return
        }
        try {
          // Ignore nunjucks because of HTTML-comment error.
          // Nunjucks removes HTML-comments.
          // Use html from window.output
          let row = activeWindow.output.Table.Rows[0]
          if (row != null) {
            for (let i = 0; i < row.length; i++) {
              if (row[i].Column.Name == $(this).attr("name")) {
                $(this).html(row[i].Value)
              }
            }
          }

          // Set id as name + windowID to make sure CKEDITOR has unique instances
          let instanceID = activeWindow.id + "|" + $(this).attr("name")
          if (activeWindow.parent) {
            instanceID = activeWindow.parent.id + "|" + $(this).attr("name")
          }

          $(this).attr("id", instanceID)
          if (CKEDITOR.instances[instanceID] == null) {
            CKEDITOR.inline($(this).get(0))
          }
        } catch (err) {
          $("body").removeClass("avoid-clicks")
          console.error(err)
        }
      })

    if (window === this.session.activeWindow) {
      $(window.element).addClass("active-window")
    }

    window.resize()

    if (window.sub && window.sub.window) {
      window.sub.window.element = $(
        '[data-window-id="' + window.sub.window.id + '"]',
      ).get(0)
    }

    if (window.output.Options) {
      if (
        window.output.Options.UploadUrl != null &&
        (window.output.Data.Type === "table" ||
          window.output.Data.Type === "quickeditform")
      ) {
        this.initializeDragAndDrop(window, window.output.Data.Type)
      } else if (window.output.Options.UploadUrl != null) {
        this.initializeDragAndDrop(window)
      }
    }

    if (window.sub && window.sub.window && window.sub.window.output.Options) {
      if (
        window.sub.window.output.Options.UploadUrl != null &&
        (window.sub.window.output.Data.Type === "table" ||
          window.sub.window.output.Data.Type === "quickeditform")
      ) {
        this.initializeDragAndDrop(window.sub.window, window.sub.window.output.Data.Type)
      } else if (window.sub.window.output.Options.UploadUrl != null) {
        this.initializeDragAndDrop(window.sub.window)
      }
    }

    // $windowScroll.scroll()
    if (!(original || window).loading) {
      $(".selection-box input[type='checkbox']", window.element).each(
        function() {
          let rowIndex = $(this)
            .closest("[data-row-index]")
            .attr("data-row-index")
          let _window = window.session.getClosestWindow(this)
          $(this).prop(
            "checked",
            typeof rowIndex !== "undefined" && !_window.bulkedit
              ? _window.isSelectedRow(rowIndex)
              : false,
          )
        },
      )

      if (
        (window.output.Request.Prefix == "New" ||
          window.output.Request.Prefix == "Single") &&
        window.options.autoFocus &&
        window.renderOptions.inactive == false
      ) {
        let $firstInput = $(window.element)
          .find("[name]")
          .first()
        let $closestCombo = $firstInput.closest(".combobox")
        if ($closestCombo.length > 0) {
          $firstInput = $closestCombo.find("input.combobox-input")
        }

        // $firstInput.focus()
      }
    }

    if (window.parent != null) {
      window.parent.renderOptions.inactive = window.bulkedit
      $(window.parent.element).toggleClass(
        "inactive",
        window.parent.renderOptions.inactive,
      )
    }

    if (window.sub != null && window.sub.window != null) {
      window.renderOptions.inactive = window.sub.window.bulkedit
      $(window.element).toggleClass("inactive", window.renderOptions.inactive)
    }

    if (window.vueTemplate) {
      this.renderVueTemplate(window.vueElementID, window.output.Data.Type)
    }
  }

  /**
   * Render a vue template
   *
   * @param {int} elementID
   * @param {string} template
   * @memberof Canvas
   */
  renderVueTemplate(elementID, template) {
    new Vue({
      el: "#" + elementID,
      data: {
        window: window,
      },
      render: h => h(template),
    })
  }

  /**
   * Set drag/drop functionality for window
   * @param {Window} window
   * @returns {void}
   */
  initializeDragAndDrop(window, type) {
    let $dragarea
    console.log({type})
    if (!type) {
      $dragarea = $(window.element)
    } else {
      $dragarea = $(window.element).find(".table-row")
    }

    $dragarea.off("drag dragstart dragend dragover dragenter dragleave drop")

    if (!type) {
      $dragarea
        .on("drag dragstart dragend dragover dragenter dragleave drop", e => {
          e.preventDefault()
          e.stopPropagation()
        })
        .on("dragenter", function() {
          $(this)
            .find(".upload-info-box")
            .toggleClass("hide", false)
        })
        .on("dragleave dragend drop", ".upload-info-box", function() {
          $(this).toggleClass("hide", true)
        })
        .on("drop", async function(e) {
          let droppedFiles = e.originalEvent.dataTransfer.files

          if (window.output.Options.UploadUrl == null) {
            alert("Je kunt hier geen bestand uploaden")
          } else {
            window.actionUploadFile(droppedFiles)
          }
        })
    } else {
      $dragarea
        .on("drag dragstart dragend dragover dragenter dragleave drop", e => {
          e.preventDefault()
          e.stopPropagation()
        })
        .on("dragenter", function() {
          $(this).css("background-color", "rgba(0,0,0,0.45)")
          $(this).css("opacity", "0.8")

          $(this).css("height", "50px")
          $(this).css("font-size", "16px")
        })
        .on("dragleave dragend drop", function() {
          let $row = $(this).closest(".table-row")

          $row.css("background-color", "")
          $row.css("height", "")
          $row.css("font-size", "")
          $row.css("opacity", "")
        })
        .on("drop", async function(e) {
          let rowID
          if ($(this)[0]) {
            rowID = $(this)[0]["data-row-index"]
          } else {
            rowID = $(this)["data-row-index"]
          }

          let requestUrl = window.output.Options.UploadUrl

          let primaryKey = window.buildCriteriaNew(
            window.output.FullTable.Rows[rowID],
          )
          let droppedFiles = e.originalEvent.dataTransfer.files

          if (requestUrl == null) {
            alert("Je kunt hier geen bestand uploaden")
          } else {
            window.actionUploadFile(droppedFiles, primaryKey)
          }
        })
    }
  }

  /**
   * Emit resize event for all windows
   * @returns {void}
   * @deprecated
   */
  emitResizeAll() {
    for (let window of this.session.tabs) {
      window.resize()
    }
  }

  /**
   * Make canvas fullscreen
   * @param {boolean} isFull - If is fullscreen
   * @returns {void}
   * @deprecated
   */
  makeFullscreen(isFullscreen) {
    if (typeof isFullscreen === "undefined") {
      throw new Error("isFull (first argument) should be specified (bool)")
    }

    this.fullscreen = isFullscreen
    this.draggers.forEach(d => (d.enabled = !this.fullscreen))
    this.move()
    $(this.element).toggleClass("fullscreen", this.fullscreen)
    if (isFullscreen) {
      $(this.element)
        .find("[data-window-anchor]")
        .css("position", "")
    }
    this.emitResizeAll()
  }

  /**
   * Move all windows(set base anchor)
   * @param {number} x - X position
   * @param {number} y - Y position
   * @returns {void}
   */
  move(x, y) {
    if (this.fullscreen) {
      return
    }

    this.x = x || 0
    this.y = y || 0

    $(this.element).toggleClass("fullscreen", this.fullscreen)

    $(this.element).css({
      "background-position": `${x}px ${y}px`,
    })

    $(this.anchorElement).css({
      position: !this.fullscreen ? "absolute" : "",
      left: this.x + "px",
      top: this.y + "px",
    })
  }

  /**
   * Set correct width for headers
   * @param {Window} window - Window element
   * @returns {void}
   */
  async correctTableHeaders(window) {
    $(".table-view", window.element).each(function() {
      const tableElement = this
      const headerRow = $(".table-index .table-row > .table-cell", tableElement)
      let firstContentRow = $(
        ".table-body .table-row > .table-cell",
        tableElement,
      )

      if (firstContentRow.length < 1) {
        firstContentRow = $(
          ".table-index .table-row > .table-row-group > .table-cell",
          tableElement,
        )
      }

      headerRow.each(function() {
        let index = $(this).index()
        let cell = firstContentRow.eq(index)

        if (!cell || !cell.length) {
          return
        }

        let width = cell.outerWidth()
        $(this).css({
          width: width,
          "min-width": width,
          "max-width": width,
        })
      })
    })

    // no clue what this did here, but caused some weird
    // looking jittering with scrollbars
    // $(".scroll-container").css("display", "block")
    // await new Promise(resolve => setTimeout(resolve, 0))
    // $(".scroll-container").css("display", "flex")
  }

  /**
   * Fix comboboxes
   * @returns {void}
   * @todo Remove if not used or not needed
   */
  static fixCombobox() {
    // fix combo width
    $(".combobox", document).each(function() {
      let $this = $(this)
      let w = $this.outerWidth()
      $this.find(".menu").css({width: w})
    })
  }

  /**
   * Open custom window, is canvas event
   * @param {string} template - Window template
   * @param {string} name - Window title
   * @param {boolean} nobar - Should the button bar be displayed
   * @todo Move to session, or streamline
   * @returns {void}
   */
  async opencustomwindow(template, name, nobar) {
    let window = await this.session.openWindow(null, template)
    window.customTitle = name || null
    window.renderOptions.actionbar = !nobar
    await window.render()

    drawVueManualModal({
      windowID: window.id,
      helpUrl: window.output.Options.HelpUrl,
    })
  }

  /**
   * Zoom in or out
   * @param {number} step - Zoom variable [0.75, 1.25]
   * @returns {void}
   */
  zoom(step) {
    let currentZoom = $("body").css("zoom")
    let zoom = step != 0 ? Number(currentZoom) + Number(step) : 1
    zoom = Math.min(1.25, Math.max(0.75, zoom))
    $("body").css("zoom", zoom)
    $("[data-zoom-value]").text((zoom * 100).toFixed(0) + "%")
    this.session.tabs.forEach(window => window.resize())
  }

  /**
   * Toggles the size of the window
   *
   * @param {object} target JQuery object of an element in the window
   * @memberof Canvas
   * @returns {void}
   */
  toggleWindowSize(target) {
    let window = $(target).closest(".window.parent")
    

    if ($(window).hasClass("window-fill-canvas")) {
      global.session.activeWindow.fullScreenSubWindow = false
      $(target).html("<i class='fad fa-expand-arrows'></i>")

      $(window).removeClass("window-fill-canvas")
    } else {
      global.session.activeWindow.fullScreenSubWindow = true
      $(window).addClass("window-fill-canvas")
      $(target).html("<i class='fad fa-compress-arrows-alt'></i>")
    }
  }

  /**
   * Bind events once
   * @returns {void}
   */
  bindEvents() {
    let _this_ = this

    $(window).resize(() => {
      if (this.fullscreen) {
        this.emitResizeAll()
      }

      Canvas.fixCombobox()
    })

    Canvas.fixCombobox()

    Hook.register("afterDispose", this, (window, e) => {
      if (window.element && !e.cancel && !window.parent) {
        $(window.element).remove()
      }
    })

    Hook.register("afterCreate", this, window => {
      if (!window.element) {
        window.element = document.createElement("div")
      }

      if (!window.parent) {
        this.anchorElement.appendChild(window.element)
      }
    })

    const breakPoints = {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
    }

    Hook.register("afterResize", this, window => {
      if (!window.element) {
        return
      }

      let $els = $(window.element)

      if (window.sub && window.sub.window && window.sub.window.element) {
        $els = $els.add(window.sub.window.element)
      }

      let realWidth = window.element.offsetWidth

      for (let breakPointName in breakPoints) {
        let className = "grid-" + breakPointName
        let minWidth = breakPoints[breakPointName]
        let enable = realWidth >= minWidth

        $els.toggleClass(className, enable)
      }

      $els.find(".scroll-container").trigger("scroll")
      Canvas.fixCombobox()
    })

    Hook.register("afterDispose", this, () => this.renderTabs())

    Hook.register("afterRender", this, window => {
      if (window.element != null && window.options.autoFocus) {
        setTimeout(() => {
          // $(window.element).find("input:enabled:visible, [contenteditable=true]").first().focus()
        }, 0)
      }

      if (
        window.output &&
        window.output.Data &&
        window.output.Data.Type == "iframe"
      ) {
        $(window.element)
          .find("iframe")
          .on("load", function() {
            // Set title
            let iframeTitle = $(this)
              .contents()
              .find("title")
              .text()
            if (iframeTitle != null && iframeTitle.length > 0) {
              window.setTitle(iframeTitle)
              session.canvas.renderTabs()
            }

            // Start download if url contains argument FileExtension
            if (
              window.output.Data.Url.indexOf("?FileExtension=") !== -1 ||
              window.output.Data.Url.indexOf("&FileExtension=") !== -1
            ) {
              window.download(window.output.Data.Url)
            }

            window.focus()
          })
      }

      /*
      // find all elements with title attribute
      let elementsTooltip = document.querySelectorAll("[title]")

      // attach a tooltip for each
      for (let i = 0; i < elementsTooltip.length; i++) {
        new bootstrap.Tooltip(elementsTooltip[i], {
          placement: "top", //string
          animation: "slideNfade", // CSS class
          delay: 0, // integer
        })
      }*/

      // render tabs to reflect window
      this.renderTabs()
    })

    $(document).on("click", "[data-window-toggle-fullscreen]", event => {
      this.toggleWindowSize(event.currentTarget)
    })

    $(document).on("click", "[data-toggle-fullscreen]", () => {
      this.makeFullscreen(!this.fullscreen)
    })

    $(this.element).on("mousedown", ".window.parent", function() {
      let window = _this_.session.getClosestWindow(this)
      window.focus()
    })

    $(this.element).on(
      "mousedown",
      "[data-window-event] input",
      async function windowEventFix(e) {
        if (e.which !== 1) {
          return
        }

        $(this)
          .closest("[data-window-event]")
          .trigger({
            type: "click",
            which: 1,
          })
      },
    )

    $(this.element).on(
      "click",
      "[data-window-event]",
      async function windowEvent(e) {
        if (e.which !== 1) {
          return
        }

        let preventdefault = $(this).attr("data-window-event-preventdefault")
        if (preventdefault != "false") {
          e.preventDefault()
          e.stopImmediatePropagation()
        }

        let eventArgs = $("<div>")
          .html($(this).attr("data-window-event"))
          .text()
        let [eventName, ...args] = eventArgs.split(/:/g)
        let elementId = $(this)
          .closest(".window")
          .attr("data-window-id")

        let target = $(this).attr("data-window-target") || elementId

        let $window = $(this).closest(".window")
        let window = _this_.session.getClosestWindow($window)

        let targetWindows

        if (target === "parent") {
          targetWindows = [window.parent]
        } else {
          targetWindows =
            target === "*"
              ? _this_.session.tabs.slice()
              : [].concat(
                  target === "active"
                    ? _this_.session.activeWindow
                    : _this_.session.windows[target],
                )
        }

        await Promise.all(targetWindows.map(w => w.event(eventName, ...args)))
      },
    )

    $("body").on("click", "[data-canvas-event]", function canvasEvent(e) {
      if (e.which !== 1) {
        return
      }

      e.preventDefault()

      let [eventName, ...args] = $(this)
        .attr("data-canvas-event")
        .split(/:/g)
      let localFn = _this_[eventName]

      if (typeof localFn !== "function") {
        console.error(new Error("Canvas event not bound to a function"))
        return
      }

      localFn.call(_this_, ...args)
    })

    $(this.element).on(
      "change",
      ".window select.number-of",
      function changeNumberOfSelectedFields() {
        if (!_this_.session.activeWindow) {
          return
        }

        let $window = $(this).closest(".window")
        let newVal = $(this).val()
        if ($window.is(".child")) {
          _this_.session.activeWindow.sub.window.pagesize(newVal)

          if (!_this_.session.activeWindow.pageIndexPerTab) {
            _this_.session.activeWindow.pageIndexPerTab = new Array(_this_.session.activeWindow.tabs.length)
          }

          if (!_this_.session.activeWindow.pageSizePerTab) {
            _this_.session.activeWindow.pageSizePerTab = new Array(_this_.session.activeWindow.tabs.length)
          }

          let tabIndex = 0
          for (let tab of _this_.session.activeWindow.tabs || []) {
            if (tab.Selected) {
              _this_.session.activeWindow.pageIndexPerTab[tabIndex] = _this_.session.activeWindow.sub.window.input.Data.PageNumber
              _this_.session.activeWindow.pageSizePerTab[tabIndex] = _this_.session.activeWindow.sub.window.input.Data.PageSize
              break
            }
            tabIndex++
          }

        } else {
          _this_.session.activeWindow.pagesize(newVal)
        }
      },
    )

    this.draggers.push(
      new Drag(
        () => [this.x, this.y],
        (target, x, y) => this.move(x, y),
        this.element,
        this.element,
        true,
      ),

      Drag.resize(".window.parent > div > [data-resize-mode]", el =>
        $(el)
          .closest(".window")
          .get(0),
      ).callback(target => {
        let id = $(target).attr("data-window-id")
        let window = _this_.session.windows[id]
        window.resize()
      }),

      Drag.absolute(".window.parent > .window-head .handle", el =>
        $(el)
          .closest(".window")
          .get(0),
      ),
    )
  }
}
